import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {GetUser} from "./helpers/User";
import Axios from "axios";
import {deleteCookie} from "./helpers/Cookie";

const ProtectedRoute = ({ component: Component, token, ...rest }) => {
    return (
        <Route {...rest} render={
            props => {
                if (token) {
                    GetUser().then(user =>{
                        if(!user){
                            delete Axios.defaults.headers.common['Authorization'];
                            deleteCookie("telos_auth");
                            return window.location.replace("/unauthorized");
                        }
                    });
                    return <Component {...rest} {...props}/>
                } else {
                    return <Redirect to={
                        {
                            pathname: '/unauthorized',
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }
        } />
    )
}

export default ProtectedRoute;